import i18n from '../i18n';
import {
  DATA_I18N_SET_LANGUAGE
} from '../constants';

export function initI18n(getState) {
  const state = getState().i18n;

  state.data.forEach(r => {
    i18n.addResourceBundle(r.lang, r.namespace, r.resource);
  });
}

export function loadLanguages(resources) {
  return dispatch => dispatch({
    type: 'i18n/DATA_SET_RESOURCES',
    status: 'SUCCESS',
    i18n: {},
    response: resources
  });
}

export const setLanguage = language => ({
  type: DATA_I18N_SET_LANGUAGE,
  payload: {
    language
  }
});



// WEBPACK FOOTER //
// ./src/actions/i18n.js